module.exports = __webpack_public_path__ + "static/img/D2000A.eb387c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/device/D2000A/D2000A.png
// module id = QrIB
// module chunks = 0